var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCuratedExp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_787_5022)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.584 36.597V4.53749C20.584 2.54927 22.1958 0.9375 24.184 0.9375H43.4507C45.439 0.9375 47.0507 2.54928 47.0507 4.5375V38.0601C47.0507 40.0483 45.439 41.6601 43.4507 41.6601H27.165",
    stroke: "#1A1E18",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3648 6.04332L30.1512 7.26432L31.5555 7.63501C32.2505 7.81848 32.5236 8.65876 32.0691 9.21573L31.1509 10.341L31.2324 11.7911C31.2727 12.5088 30.5578 13.0282 29.8878 12.768L28.5339 12.2424L27.1799 12.768C26.5099 13.0282 25.7951 12.5088 25.8354 11.7911L25.9168 10.341L24.9987 9.21573C24.5442 8.65885 24.8172 7.81848 25.5122 7.63501L26.9165 7.26432L27.703 6.04332C28.092 5.43901 28.9756 5.43901 29.3648 6.04332Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.4023 12.8361H42.8583M36.4023 7.83789H42.8583",
    stroke: "#1A1E18",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3648 18.1095L30.1512 19.3305L31.5555 19.7012C32.2505 19.8846 32.5236 20.7249 32.0691 21.2819L31.1509 22.4072L31.2324 23.8573C31.2727 24.575 30.5578 25.0943 29.8878 24.8342L28.5339 24.3086L27.1799 24.8342C26.5099 25.0943 25.7951 24.575 25.8354 23.8573L25.9168 22.4072L24.9987 21.2819C24.5442 20.725 24.8172 19.8846 25.5122 19.7012L26.9165 19.3305L27.703 18.1095C28.092 17.5052 28.9756 17.5052 29.3648 18.1095Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.4023 24.9022H42.8583M36.4023 19.9041H42.8583",
    stroke: "#1A1E18",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3648 30.1756L30.1512 31.3966L31.5555 31.7673C32.2505 31.9508 32.5236 32.7911 32.0691 33.3481L31.1509 34.4733L31.2324 35.9235C31.2727 36.6411 30.5578 37.1605 29.8878 36.9004L28.5339 36.3749L27.1799 36.9004C26.5099 37.1606 25.7951 36.6412 25.8354 35.9235L25.9168 34.4733L24.9987 33.3481C24.5442 32.7912 24.8172 31.9508 25.5122 31.7673L26.9165 31.3966L27.703 30.1756C28.092 29.5713 28.9756 29.5713 29.3648 30.1756Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.4016 36.9683H42.8576M36.4016 31.9703H42.8576M13.0932 37.524L18.7952 42.2209C19.8053 43.0529 21.2811 42.9803 22.205 42.053C23.2133 41.0408 23.1956 39.3965 22.1657 38.4063L14.0422 30.5962C12.8256 29.4254 11.2029 28.7712 9.51448 28.7708H9.4378C8.13214 28.7708 6.93673 29.5038 6.34302 30.6685H0.951172V38.9385H5.64092M5.64092 38.9385L12.9111 45.9398C13.6586 46.66 14.6561 47.0624 15.694 47.0625H30.6653C32.1547 47.0625 33.362 45.8531 33.362 44.3613C33.362 42.8694 32.1546 41.6601 30.6653 41.6601H22.645M5.64092 38.9385L5.64083 35.4741",
    stroke: "#1A1E18",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_787_5022"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCuratedExp);
export default __webpack_public_path__ + "static/media/curated-exp.786cbc4a4bcfa59dce06c684bf4cd1f7.svg";
export { ForwardRef as ReactComponent };